<template>
<label class="btn btn-{{ buttonStyle }}
              {{ buttonSize ? `btn-${buttonSize}` : '' }}
              {{* checked ? 'active' : '' }}"
       @click="handleClick">
  <input type="checkbox">
  <slot></slot>
</label>
</template>


<script>
export default {
  props: {
    value: {
      required: true,
    },
    checked: {
      type: Boolean,
      default: null,
    },
    buttonStyle: {
      type: String,
      default: 'default',
    },
    buttonSize: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClick() {
      let i = this.$parent.values.indexOf(this.value)
      if (i >= 0) {
        this.$parent.values.splice(i, 1)
        this.checked = false
      } else {
        this.$parent.values.push(this.value)
        this.checked = true
      }
    },
  },
  created() {
    if (this.checked === null) {
      this.checked = this.$parent.values.includes(this.value)
    } else if (this.checked && !this.$parent.values.includes(this.value)) {
      this.$parent.values.push(this.value)
    } else if (!this.checked && this.$parent.values.includes(this.value)) {
      let i = this.$parent.values.indexOf(this.value)
      this.$parent.values.splice(i, 1)
    }
  },
}
</script>



// WEBPACK FOOTER //
// checkbox-button.vue?25159d56